import ServiceDelayBanners from './ServiceDelayBanners';

export default ServiceDelayBanners;
